import { Component, Input } from '@angular/core';

import {
  MessstelleKategorie,
  MessstelleKategorieAbschnitt
} from '../../../Models/messstelle.model';

/**
 * Die Prüfstruktur einer Kategorie zum Nachlesen: Abschnitte, darunter die
 * Prüfpunkt-Vorlagen in ihrer Reihenfolge.
 *
 * Rein lesend und ohne eigenen Datenabruf – die Struktur kommt mit der
 * Kategorie (`GET inbetriebnahme/kategorien` bzw. aus dem Offline-Paket).
 * Wird von der Kategorieauswahl als Vorschau eingeblendet, lässt sich aber
 * genauso einzeln verwenden.
 */
@Component({
  selector: 'app-kategorie-vorschau',
  templateUrl: './kategorie-vorschau.component.html',
  styleUrls: ['./kategorie-vorschau.component.css']
})
export class KategorieVorschauComponent {

  /** Name des Sammelabschnitts für Vorlagen ohne Abschnitt – wie serverseitig. */
  static readonly ABSCHNITT_ALLGEMEIN = 'Allgemein';

  @Input({ required: true }) kategorie!: MessstelleKategorie;

  /** Kopf mit Name und Beschreibung anzeigen? Aus, wenn der Kontext ihn schon zeigt. */
  @Input() mitKopf = true;

  /**
   * Abschnitte in Anzeigereihenfolge. Vorlagen ohne Abschnitt (Altbestand)
   * hängen als „Allgemein“ hinten an – genau dort landen sie auch als
   * konkrete Prüfpunkte.
   */
  get abschnitte(): MessstelleKategorieAbschnitt[] {
    const abschnitte = [...(this.kategorie?.abschnitte ?? [])];
    const ohne = this.kategorie?.vorlagenOhneAbschnitt ?? [];

    if (ohne.length > 0) {
      abschnitte.push({
        id: 0,
        name: KategorieVorschauComponent.ABSCHNITT_ALLGEMEIN,
        sortOrder: Number.MAX_SAFE_INTEGER,
        vorlagen: ohne
      });
    }

    return abschnitte;
  }

  get anzahlPruefpunkte(): number {
    const gezaehlt = this.abschnitte.reduce((summe, a) => summe + a.vorlagen.length, 0);

    // Fehlt die Struktur (alter lokaler Bestand), bleibt wenigstens die Zahl.
    return gezaehlt > 0 ? gezaehlt : (this.kategorie?.vorlagenCount ?? 0);
  }

  get strukturVerfuegbar(): boolean {
    return this.abschnitte.length > 0;
  }
}
